import React from 'react';
import { NavLink } from 'react-router-dom';
import { legalDocs } from '../../data/legal';

/**
 * The set of legal documents, as a real navigation landmark on every legal
 * page. This stands in for a /legal index page: a persistent list you can
 * move between documents with beats a page of links you have to go back to
 * each time.
 *
 * The accessibility of it is the point rather than a side effect:
 * - it is a `nav` with its own accessible name, so a screen reader can
 *   reach it from the landmark list on any legal page,
 * - `NavLink` sets `aria-current="page"` on the document being read, so
 *   position is conveyed programmatically and not by colour,
 * - the current item also carries a flame rule and bold weight, so the
 *   same information survives without perceiving colour,
 * - every row is at least 44px, and
 * - it is ordinary markup in source order, so it reads as it looks.
 */
const itemClass = ({
  isActive
}: {
  isActive: boolean;
}) => `flex min-h-[44px] items-center border-l-2 px-3 py-2 text-sm transition-colors duration-200 ease-out-expo ${isActive ? 'border-flame font-bold text-ink' : 'border-transparent font-medium text-ink-muted hover:border-control hover:text-ink'}`;
export function LegalNav() {
  return <nav data-component-id="C34" aria-label="Legal documents" className="rounded-container border border-hairline bg-white p-4" data-id="element-55" data-mp="wxaarlfvyt5z">
      <h2 className="px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-56" data-mp="hz86ta4y05o7">
        Legal documents
      </h2>
      <ul className="mt-2 flex flex-col" data-id="element-57" data-mp="mwzxk0tuplqt">
        {legalDocs.map(doc => <li key={doc.slug} data-id="element-58" data-mp="90w78im3lxjm">
            <NavLink to={`/legal/${doc.slug}`} className={itemClass} data-id="element-59" data-mp="91o37ujlxxaf">
              {doc.title}
            </NavLink>
          </li>)}
        <li data-id="element-60" data-mp="23d2pu2hbngly">
          <NavLink to="/legal/company-details" className={itemClass} data-id="element-61" data-mp="23enmpyr3zbmz">
            Business details
          </NavLink>
        </li>
      </ul>
    </nav>;
}